// src/chatbot/OneDeployment.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
You are Fireside Chat-bot interviewing someone about ONE specific military deployment.
They may be from any branch of the UK armed forces or other services.
Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material (~5,000 words) about ONE deployment: clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Updated questions to the final agreed One Deployment set
const questions = [
  
  {
    text: "To set the scene, could you talk a little about your military career leading up to this deployment?",
    followups: 1,
    placeholder: "You could talk about your inspiration for joining up or how you came to be part of this unit or platform."
  },
  {
    text: "Which deployment would you like to talk about and what was your role on it? How did you come to be in that position?",
    followups: 1,
	placeholder: "If you haven't already, name the deployment and set the scene."
  },
  {
    text: "Can you describe what daily life was like there? What were your daily routines and rituals?",
    followups: 2,
    placeholder: "Think about routines, timings, people, places, and a day that broke the pattern."
  },
  {
    text: "Could you talk about a day that stands out as different from the rest?",
    followups: 2,
    placeholder: "This could be anything at all. Work, social, people, places..."
  },
  {
    text: "If you were going to tell one story from that deployment, which would it be?",
    followups: 2,
	 placeholder: "Any story - remember you can repeat this interview to tell another story!"
  },
  {
    text: "Which people during this period of time made a lasting impression on you? ",
    followups: 2,
	placeholder: "A boss, a friend, a local you met?"
  },
  {
    text: "When you look back on the deployment, what do you think had the greatest impact on you?",
    followups: 2,
	placeholder: "This could be anything at all. Work, social, people, places..."
  },
  {
    text: "Is there anything we haven’t talked about that you think is important to mention?",
    followups: 1,
	placeholder: "Anything at all, including notes for the editor if needed"
	
  }
];

export default function OneDeployment() {
  return (
    <ChatbotCore
      title="One Deployment"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
